// VantageLabs aperture / camera-iris logo mark. A clean vector recreation of
// the brand image — six blades in two teal tones around a hexagonal opening.
function ApertureMark({ className, title = 'VantageLabs' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M50 4 A 46 46 0 0 1 89.84 27 L 62.99 42.5 Z" fill="#3cc3cb" />
      <path d="M89.84 27 A 46 46 0 0 1 89.84 73 L 62.99 57.5 Z" fill="#1f9aa6" />
      <path d="M89.84 73 A 46 46 0 0 1 50 96 L 50 65 Z" fill="#3cc3cb" />
      <path d="M50 96 A 46 46 0 0 1 10.16 73 L 37.01 57.5 Z" fill="#1f9aa6" />
      <path d="M10.16 73 A 46 46 0 0 1 10.16 27 L 37.01 42.5 Z" fill="#3cc3cb" />
      <path d="M10.16 27 A 46 46 0 0 1 50 4 L 50 35 Z" fill="#1f9aa6" />
    </svg>
  );
}

export default ApertureMark;
